const columnOverrides = [
  {
    field: 'ativo',
    renderCell: ({ value }) => (
      <div style={colorContainer(value)}>
        <span>{value}</span>
      </div>
    ),
  },
  {
    field: 'preco',
    valueGetter: ({ value }) =>
      value && value.toLocaleString('pt-br', { minimumFractionDigits: 2 }),
  },
];

const colorContainer = (value) => ({
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor:
    value === 'SIM' ? '#baffc9' : value === 'NAO' ? '#ffb3ba' : '#ffffba',
});

export default columnOverrides;
